const accounts = "accounts";
const job = "job";
const interviews = "interviews";
const practice = "practice";
const subscription = "subscription";
const demo = "demo";
const company = "company";
const jobSeekers = "jobseekers";
const ai = "ai";
const core = "core";
const notes = "notes";
const telecmi = "telecmi_calls";
const leadCandidates = "lead_candidates";
const userManagement = "user_management";
const activityLogs = "activity_logs";

export const subscribeToNewsletter = `subscribe_newsletter/subscribe/`; //subscribe to newsletter

//login - registration routes

export const socialLogin = `${accounts}/social-login/`; //social login
export const checkPhoneExists = `${accounts}/check-phone-exists/`; //check phone number exists
export const sendEnquiry = `${accounts}/send-inquiry/`; //send contact form
export const checkUserExists = `${accounts}/check-user-exists`; //check user exists
export const getUserCredits = `${accounts}/user-credits/`; //current user credit balance

//job creation and management routes
export const createjob = `${job}/create-job/`; //create job
export const updatejob = `${job}/update-job`; //update job
export const getJobDetails = `${job}/job-details`; //get job details
export const checkjobStatus = `${job}/check-job-status`; //check job status
export const searchJobs = `${job}/search-jobs/`; //search jobs
export const recentJobList = `${job}/${company}/dashboard-job-lists/`; //recent job list
export const dashboardCounts = `${job}/${company}/dashboard-counts/`; //dashboard filter counts
export const jobListingJobSeeker = `${job}/jobs-listing-for-jobseeker/`; //job listing for job seeker
export const getJobApplications = `${job}/my-candidates/`; //get job applications
export const getAllJobApplications = `${job}/my-candidates/`; //get all job applications
export const getCompanyMyCandidates = `${job}/my-candidates/`; //get my candidates filtered by client_id (for View Client Job Applicant tab)
export const exportMyCandidatesCSV = `${job}/my-candidates/export-csv/`; //download my-candidates list as CSV (same query params as the list API, pagination ignored)
export const manualApplicationFollowupStage2 = `${job}/manual-application-followup-stage2/`; //manually trigger stage-2 follow-up email for a job application
export const applyjob = `${jobSeekers}/apply-job/`; //apply for job
export const requestinterview = `${jobSeekers}/request-interview/`; //request interview
export const reportjob = `${job}/report-job`; //report job
export const jobInvite = `${job}/job-invite`; //job invite`
export const getJobData = `${job}/job-data/`; //get job data
export const getJobApplicationDetails = `${job}/${company}/get-jobseeker-application-details`; //get job application details
export const addNote = `${job}/${company}/add-note`; //add note to job application
export const createNote = `${notes}/create-note/`; //create note
export const getNotesList = `${notes}/notes-list/`; //get notes list with candidate applications

//interview routes
export const createinterview = `${interviews}/create-interview/`; //create interview
export const checkinterviewAssesment = `${interviews}/check-interview-assessment`; //check interview assessment
export const initiateMultipartUpload = `${interviews}/initiate-multipart-upload`; //initiate multipart upload
export const getPresignedUrl = `${interviews}/get-presigned-url`; //get presigned url
export const incrementTabSwitchCount = `${interviews}/increment-tab-switch`; //increment tab switch count
// increment-external-screen is intentionally absent: external-screen strikes are
// written ONLY as typed `external_screen` proctor events via `proctorEvent` below.
export const completeMultipartUpload = `${interviews}/complete-multipart-video-upload`; //complete multipart upload
export const updateResponseDelayed = `${interviews}/update-response-delayed-in-interview`; //update response delayed
export const generateInterviewInterpretations = `${interviews}/generate-interpretations`; //generate interview interpretations
export const generateInterviewAssessment = `${ai}/generate-assessment`; //generate interview assessment
export const initializeVideoUploadContainer = `${interviews}/intialization-video-upload-container`; //initialize container
export const screenRecordingDetails = `${interviews}/screen-recording-details`; //get screen recording details
export const initializeInterviewServiceContainer = `${interviews}/intialization-interview-service-container`; //initialize conversation container
export const interviewLogSessionInfo = `${interviews}/interview-log-session-info`; //poll conversation container status
export const voiceEnrollmentUploadUrl = `${interviews}`; //presigned PUT for the voice-enrollment clip: `${voiceEnrollmentUploadUrl}/${interviewId}/voice-enrollment-url/`
export const netCheckUpload = `${core}/netcheck-upload/`; //upload-throughput probe for the pre-interview network gate (streams+discards body, returns {bytes, seconds})
export const proctorEvent = (interviewId) => `${interviews}/proctor-event/${interviewId}/`; //typed proctor events, always a batch: { events: [...] }
export const reviewBundle = (interviewId) => `${interviews}/review-bundle/${interviewId}/`; //recruiter-only: video + events + turns + gaps + summary for the review page

//practice routes
export const practiceInterview = `${practice}/interview/`; //practice interview
export const practiceLatestAssigments = `${practice}/latest-assignments/`; //practice latest assignments
export const createPracticeAssesmentAttempt = `${practice}/attempts/`; //create practice attempt
export const getPracticeAssesmentAttempt = `${practice}/attempts`; //get practice attempt details
export const practiceAssesmentQuestionResponse = `${practice}/responses/`; //practice assessment question response

//company routes
export const createcompany = `${company}/create_company/`; //create company
export const getCompanyDetails = `${company}/company-details`; //get company details
export const getCompanyDetailsRecruiter = `${company}/company-details-for-recruiter`; //get company details
export const updatecompany = `${company}/update-company`; //update company
export const extractCompanyData = `${company}/extract-data/`; //extract company data from email

//job seeker routes
export const createJobseeker = `${jobSeekers}/create/`; //create job seeker
export const updateJobseeker = `${jobSeekers}/update`; //update job seeker
export const getRecommendationAfterUpdate = `${jobSeekers}/get-recommendation-after-update/`; //get recommendations after profile update
export const getJobSeekerDetails = `${jobSeekers}/jobseeker-details`; //get job seeker details
// Current user’s own jobseeker record - takes no id, 404s when none exists.
export const getResumeJsonForCurrentUser = `${jobSeekers}/get-resume-json/`;

//subscriptions routes
export const subscriptionConfig = `${subscription}/config/`; //subscription config
export const createCheckoutSession = `${subscription}/create-checkout-session/`; //create checkout session
export const topupPurchase = `${subscription}/topup/purchase/`; //topup purchase order
export const razorpayCreateCheckoutSession = `${subscription}/razorpay/create-checkout-session/`; //razorpay create checkout session
export const razorpayTopupCheckoutSession = `${subscription}/razorpay/topup-checkout-session/`; //razorpay topup checkout session (legacy)
export const razorpayOrderComplete = `${subscription}/razorpay/order/complete/`; //razorpay order complete
export const getSubscriptionHistory = `${subscription}/get-subscription-history/`; //get subscription history
export const getBillingInfo = `${subscription}/get-billing-info/`; //get billing info
export const addBillingAddress = `${subscription}/add-billing-address/`; //add billing address
export const getCreditHistory = `${subscription}/get-credit-history/`; //get credit history
export const subscriptionDetailsRoute = `${subscription}/subscription-details/`; //active subscription details

//ai routes
export const transcribeBase64 = `${ai}/transcribe_base64/`; //transcribe base64 audio
export const checkAnswer = `${ai}/answer_check/`; //check answer
export const generatePresignedUrl = `${ai}/generate-presigned-url/`; //generate presigned url for file upload
export const generateKeyword = `${ai}/keyword_generate/`; //generate keyword
export const checkJobTitleAvailability = `${ai}/check-job-title-availability`; //check if job title already exists
//demo routes
export const listDemoInterviews = `${demo}/list-demo-interviews/`; //list demo interviews
export const applicationsListForDemo = `${demo}/job-application-list-for-demo-job/`; //applications list for demo
export const checkDemoInterviewAssesment = `${demo}/check-demo-interview-assessment`; //check demo interview assessment
export const incrementDemoTabSwitchCount = `${demo}/increment-tab-switch-count-for-demo-interview`; //increment demo tab switch count
export const updateDemoResponseDelayed = `${demo}/update-response-delayed-flag`; //update response delayed in demo interview

//telecmi routes
export const createTelecmiCallLog = `${telecmi}/call-logs/create/`; //create telecmi call log
export const getTelecmiCallLogs = `${telecmi}/call-logs/`; //list telecmi call logs
export const getTelecmiAgents = `${telecmi}/telecmi/agents/`; //get telecmi agents
export const getCallRecording = `${telecmi}/calls`; //get call recording - will be used as: /telecmi_calls/calls/{call_id}/recording/

//lead candidates routes
export const createLeadCandidate = `${leadCandidates}/create-candidate-lead-form/`; //create lead candidate
export const getLeadCandidateDetails = `${job}/lead-candidate/details/`; //get lead candidate details
export const updateLeadCandidateStatus = `${leadCandidates}/update-candidate-lead-status/`; //update lead candidate status

//client sharing routes
export const sharedApplicationsDashboard = `application_sharing/shared-applications-dashboard/`; //get shared applications dashboard
export const sharedApplicationsDashboardCounts = `application_sharing/dashboard-counts/`; //get filter drawer counts for client
export const shareApplication = `application_sharing/share-application/`; //share application with team
//application sharing / client feedback routes
export const getJobseekerProfileForClient =
  "application_sharing/get-jobseeker-profile-details-for-client/"; //GET jobseeker profile details for client view
export const listClientFeedback = "application_sharing/list-feedback"; //GET application_sharing/list-feedback/{jobId}/
export const updateFeedbackStatus = `application_sharing/update-feedback-status/`; //POST update feedback status (Accepted/Rejected)
export const listFeedbackForJobApplications =
  "application_sharing/list-feedback-for-job-applications/"; //GET list feedback for a job application
export const addFeedbackForJobApplication = "application_sharing/add-feedback/"; //POST add feedback: .../add-feedback/{job_application_id}/
export const markFeedbacksAsSeen = "application_sharing/feedbacks-seen/"; //POST mark feedbacks as seen
export const sharedJobsListing = `application_sharing/shared-jobs/`; //GET shared jobs listing for client
export const clientAgencies = "application_sharing/client-agencies/"; //GET list of agencies for filter

//user management / team members routes
export const getMembersCount = `${userManagement}/members/count/`; //GET team member counts for KPI cards
export const getMembersList = `${userManagement}/members/`; //GET team members list (params: search, filter_type)
export const getMembersDetail = `${userManagement}/members/detail/`; //GET member(s) detail (params: member_id, exclude_member_id, search, limit, offset, job_ids)
/** GET minimal team list for filters: [{ id, name, user_id }, ...] */
export const getMembersSimpleList = `${userManagement}/members/simple/`;
/** POST. Full reassign+delete: { previous_member_id, new_member_id }. Partial reassign only: same path + { job_ids: number[] }. */
export const reassignDeleteMember = `${userManagement}/members/reassign-delete/`;
export const inviteMember = `${userManagement}/members/invite/`; //POST send invitations (body: [{ email, group }])
export const editMemberProfile = `${userManagement}/members/edit-profile/`; //PUT update member first_name, last_name (invited members)

// my clients (Agency only)
export const getClientsCount = "my_client/count/"; //GET client counts (total, active, inactive, active_jobs)
export const getClientsList = "my_client/list/"; //GET clients list (params: limit, offset, filter_type, search)
export const getClientInfo = (id) => `my_client/client-info/${id}/`; //GET client info details with jobs table
export const createClient = "my_client/create/"; //POST create a new client
export const editClient = (id) => `my_client/edit/${id}/`; //PUT edit client
export const changeClientStatus = (id) => `my_client/change-status/${id}/`; //PATCH change status
export const deleteClient = (id) => `my_client/delete/${id}/`; //DELETE client from agency
export const getActivityLogs = `${activityLogs}/list-logs/`; //GET activity logs list
export const getActivityLogUserList = `${activityLogs}/user-list/`; //GET members for activity log user filter
export const getClientActivityLogs = (clientId) =>
  `my_client/activity-logs/${clientId}/`; //GET activity logs for a specific client
export const reinviteMember = (memberId) =>
  `${userManagement}/members/${memberId}/reinvite/`; //POST resend invitation to member by id
// SECURITY: backend must enforce ownership — reject requests where the
// authenticated user does not own the blob being deleted.
export const deleteBlobObject = `bs3/objdelbc/`; //DELETE uploaded blob object by URL

//AI Job Posting routes
const jobPostingAi = "job_posting_ai";
export const createJobPostingSession = `${jobPostingAi}/session/`; //POST create/reconnect job posting AI session
export const memberGroupChange = `${userManagement}/members/group-change/`; //POST change member group (body: { member_id, group })
/** POST deactivate a member, optionally reassigning their jobs ({ previous_member_id, new_member_id? }). */
export const deactivateMemberRoute = `${userManagement}/members/deactivate/`;
/** POST reactivate a previously deactivated member ({ member_id }). */
export const reactivateMemberRoute = `${userManagement}/members/reactivate/`;
export const validateInviteLink = `${userManagement}/members/validate-link/`; //POST validate invitation link (body: { email, mail_token })
export const getAdminRecruiterStats = `${userManagement}/admin-recruiter-stats/`; //GET admin or recruiter stats (params: admin_id or recruiter_id, filter, search)

// my requirements (recruiter)
export const getRequirementsList = "myrequirements/requirements-list/"; //GET requirements list (params: limit, offset, etc.)
export const getRecruiterList = "myrequirements/recruiter-list/"; //GET recruiter list for assign requirement
export const getClientListForAgency = "myrequirements/client-list/"; //GET client list for agency owner/admin
export const checkRequirementTitleAvailability =
  "myrequirements/check-requirement-title-availability/"; // POST check requirement title
export const updateRequirementDetail = (id) =>
  `myrequirements/requirement-detail/${id}/`; // POST update requirement detail
export const createRequirementDetail = "myrequirements/requirement-detail/"; // POST create requirement (same payload as update)
export const getJobsAndApplicants = (requirementId) =>
  `myrequirements/jobs-and-applicants/${requirementId}/`; // GET type=1 jobs, type=2 applicants (params: type, limit, offset)
export const generateRequirementNotes =
  "myrequirements/generate-requirement-notes/"; // POST generate AI notes for a requirement
